import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SendaRoles } from '../features/roles/components/sendaRoles';

/**
 * `/roles` (T-4.1): ruta pública, sin guarda — igual que `/saber-mas` e `/instalar`, cualquiera
 * puede verla, con sesión o sin ella. Hoy `SendaRoles` solo se montaba embebida bajo el formulario
 * de acceso en `routes/login.tsx` (oleada 3); esta ruta le da un destino propio para el botón «ver
 * roles» del teaser que sustituirá a esa senda embebida en `/login` (tarea de otra oleada, todavía
 * sin enlazar aquí a propósito — nada en este repositorio enlaza a `/roles` todavía).
 *
 * `<h1 className='sr-only'>` (H-29, rutas sin ningún encabezado de primer nivel): `SendaRoles`
 * está pensada para vivir dentro de otra pantalla (JSDoc del propio componente) y solo trae un
 * `<h2>` como título visible (`roles:encabezado`), nunca un `<h1>` — no le corresponde decidir si
 * algún día la monta una ruta completa o un fragmento de página, y está congelada para esta tarea.
 * El `<h1>` de esta ruta lo aporta este fichero, con el mismo texto que ese `<h2>` en vez de
 * inventar una clave nueva — mismo patrón que `features/bienvenida/components/bienvenida.tsx`
 * (`MissionCard`, título visible en un `<h3>`): dos nodos con el mismo texto, uno accesible (este
 * `h1`) y otro visual (el `h2` de `SendaRoles`).
 */
export const Route = createFileRoute('/roles')({ component: PantallaRoles });

function PantallaRoles(): React.JSX.Element {
	const { t } = useTranslation('roles');

	return (
		<div className='mx-auto max-w-3xl'>
			<h1 className='sr-only'>{t('encabezado')}</h1>
			<SendaRoles />
		</div>
	);
}
